module.exports = __webpack_public_path__ + "img/paneles-solares.7aa0cc89.svg";